import { render, staticRenderFns } from "./PolizasRMSListView.vue?vue&type=template&id=030d40d9&"
import script from "./PolizasRMSListView.vue?vue&type=script&lang=js&"
export * from "./PolizasRMSListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports